var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasBindData.isExistShop
    ? _c(
        "div",
        { staticClass: "order-page" },
        [
          _c(
            "el-card",
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.handleTabClick },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: {
                      label: _vm.$t("stores::order::all"),
                      name: _vm.tabMode.all,
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      label: _vm.$t("stores::order::wait"),
                      name: _vm.tabMode.toBeShipped,
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      label: _vm.$t("stores::order::shipping"),
                      name: _vm.tabMode.shipped,
                    },
                  }),
                ],
                1
              ),
              _c("z-search", {
                ref: "search",
                attrs: {
                  watchValue: _vm.activeTab,
                  configs: _vm.searchConfigs,
                },
                on: { "do-query": _vm.query, init: _vm.handleSearch },
                model: {
                  value: _vm.searchForm,
                  callback: function ($$v) {
                    _vm.searchForm = $$v
                  },
                  expression: "searchForm",
                },
              }),
            ],
            1
          ),
          _c(
            "el-card",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c(
                "el-row",
                { staticClass: "mb-16" },
                [
                  _c(
                    "el-col",
                    { staticStyle: { "text-align": "right" } },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "stores::order::export",
                              expression: "'stores::order::export'",
                            },
                          ],
                          staticStyle: { "margin-left": "10px" },
                          attrs: { loading: _vm.exportLoading },
                          on: { click: _vm.exportOrders },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("stores::order::export")) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "z-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "table",
                  attrs: {
                    columns: _vm.columns,
                    data: _vm.orderList,
                    "max-height": 480,
                    pagination: _vm.pagination,
                  },
                  on: {
                    "update:pagination": function ($event) {
                      _vm.pagination = $event
                    },
                    "cell-mouse-enter": _vm.hoverShow,
                    "cell-mouse-leave": _vm.hideShow,
                    "page-change": _vm.handlePageChange,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "orderNo",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "p",
                              [
                                _c("span", { staticClass: "item-orderNo" }, [
                                  _vm._v(_vm._s(row.orderNo)),
                                ]),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      content: _vm.editText.copy_order,
                                      effect: "dark",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "iconfont iconcopy",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return function () {
                                            return _vm.handleCopy(row.orderNo)
                                          }.apply(null, arguments)
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                row.riskStatus
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [_vm._v(_vm._s(_vm.editText.risk_order))]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "sourceNo",
                        fn: function (ref) {
                          var row = ref.row
                          return [_vm._v(_vm._s(_vm.$dataCheck(row.sourceNo)))]
                        },
                      },
                      {
                        key: "consigneeName",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("p", { staticClass: "consignee-name" }, [
                              _vm._v(
                                _vm._s(row.firstName || "-") +
                                  " " +
                                  _vm._s(row.lastName || "-")
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "payTotalAmount",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(row.payTotalAmount.toFixed(2))
                              )
                            ),
                          ]
                        },
                      },
                      {
                        key: "quantity",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: { position: "relative" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _vm._v(" " + _vm._s(row.quantity) + " "),
                                _c("OrderGoods", {
                                  attrs: { activeRow: _vm.activeRow, row: row },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "title",
                        fn: function (ref) {
                          var row = ref.row
                          return [_vm._v(_vm._s(_vm.$dataCheck(row.title)))]
                        },
                      },
                      {
                        key: "mallType",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(_vm.PLATFORM[row.mallType]))
                            ),
                          ]
                        },
                      },
                      {
                        key: "shopName",
                        fn: function (ref) {
                          var row = ref.row
                          return [_vm._v(_vm._s(_vm.$dataCheck(row.shopName)))]
                        },
                      },
                      {
                        key: "payStatus",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(_vm.PAY_STATUS[row.payStatus])
                              )
                            ),
                          ]
                        },
                      },
                      {
                        key: "fulfillmentStatus",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  row.fulfillmentStatus
                                    ? _vm.$dataCheck(
                                        _vm.FULFILMENTSTATUS[
                                          row.fulfillmentStatus
                                        ]
                                      )
                                    : "--"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "salesStatus",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(
                                  _vm.SALES_STATUS[row.salesStatus]
                                )
                              )
                            ),
                          ]
                        },
                      },
                      {
                        key: "payType",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            row.payType
                              ? _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$dataCheck(_vm.PAY_TYPE[row.payType])
                                    )
                                  ),
                                ])
                              : _c("p", [_vm._v(_vm._s(row.gateway))]),
                          ]
                        },
                      },
                      {
                        key: "createTime",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("p", [
                              _vm._v(_vm._s(_vm.$dataCheck(row.createTime))),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "payTime",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("p", [
                              _vm._v(_vm._s(_vm.$dataCheck(row.payTime))),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "refundStatusCode",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              _vm._s(
                                row.shipmentStatus ? row.shipmentStatus : "-"
                              )
                            ),
                          ]
                        },
                      },
                      {
                        key: "bindShop",
                        fn: function (ref) {
                          var row = ref.row
                          return [_vm._v(_vm._s(row.shopName))]
                        },
                      },
                      {
                        key: "operation",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "auth",
                                    rawName: "v-auth",
                                    value: "stores::order::detail",
                                    expression: "'stores::order::detail'",
                                  },
                                ],
                                staticClass: "shipment-btn",
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleDetail(row)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.editText.detail) + " ")]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4011511482
                  ),
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.$t("stores::order::message_cancel"),
                visible: _vm.isCancelModalShow,
                width: "40%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.isCancelModalShow = $event
                },
              },
            },
            [
              _c("p", { staticStyle: { "margin-bottom": "10px" } }, [
                _vm._v(
                  _vm._s(_vm.$t("stores::order::platform_order")) +
                    "：" +
                    _vm._s(_vm.cancelModalData.orderNo)
                ),
              ]),
              _c("p", { staticStyle: { "margin-bottom": "10px" } }, [
                _vm._v(
                  _vm._s(_vm.$t("stores::order::store_order")) +
                    "：" +
                    _vm._s(_vm.cancelModalData.sourceNo)
                ),
              ]),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("stores::order::message_cancel_tips"))),
              ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.isCancelModalShow = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.submitConfirmCancel },
                    },
                    [_vm._v(_vm._s(_vm.$t("system::common::btn::confirm")))]
                  ),
                ],
                1
              ),
            ]
          ),
          _c("shipDialog", {
            attrs: { orderDetail: _vm.isSendModalData },
            on: {
              getDetail: function ($event) {
                return _vm.getList([], false)
              },
            },
            model: {
              value: _vm.isSendModalShow,
              callback: function ($$v) {
                _vm.isSendModalShow = $$v
              },
              expression: "isSendModalShow",
            },
          }),
        ],
        1
      )
    : _c(
        "div",
        [
          _c("emptyCard", {
            attrs: {
              data: {
                title: _vm.$t("stores::order::empty_title"),
                img: require("@/assets/images/emptyDefault/order@2x.png"),
                desc: _vm.$t("stores::order::empty_text"),
                buttons: [
                  {
                    click: _vm.onBindShop,
                    text: _vm.$t("stores::order::empty_button"),
                    auth: "stores::store::add",
                  },
                ],
              },
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }